import React from 'react';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ 
      backgroundColor: '#293A41',
      backgroundImage: 'url(/background.jpg)',
      backgroundPosition: 'bottom',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      backgroundAttachment: 'fixed'
    }}>
      <div className="text-center" style={{ opacity: 1 }}>
        {/* Animated loading spinner with pulsing effect */}
        <div className="relative">
          <div className="w-16 h-16 border-4 border-gray-300 rounded-full animate-spin mx-auto" style={{ borderTopColor: '#F96423' }}></div>
          <div className="absolute inset-0 w-16 h-16 border-4 border-transparent rounded-full animate-ping mx-auto" style={{ borderTopColor: '#F96423', opacity: 0.6 }}></div>
        </div>
        <div className="mt-6">
          <h3 className="text-lg font-semibold mb-2" style={{ color: '#4B5563' }}>
            Loading files...
          </h3>
          <p style={{ color: '#6B7280' }}>
            Please wait while we fetch your files
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
